<template>
  <section :class="sectionClass" class="block block-advice">
    <div class="container container--max-wide">
      <div class="row">
        <div class="quick-advice flex text-center align-center">
          <div class="quick-advice__icon">
            <NuxtImg
              alt="Need information or advice on elder abuse now?"
              height="168"
              loading="lazy"
              src="/img/quick-advice_icon.png"
              width="168"
            />
          </div>
          <div class="quick-advice__content">
            <div class="h2">Need information or advice on elder abuse now?</div>
            <a aria-label="Call 1080 ELDERHelp" href="tel: 1800 353 374">
              CALL 1800 ELDERHelp (
              <strong> 1800&nbsp;353&nbsp;374 </strong>
              )
            </a>
            <br class="always" />
            <a
              aria-label="Call 000 in emergency"
              class="emergency"
              href="tel: 000"
            >
              In an emergency call 000
            </a>
            <p>
              This free number will redirect you to an existing phone service
              near you. This is not a 24-hour line. Call operating times will
              vary. A collaboration between the Australian, state and territory
              governments.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlockAdviceStoryblok } from '~/types/storyblok'

const props = defineProps<{ blok: BlockAdviceStoryblok }>()
const { sectionClass } = useStoryContent(toRefs(props))
</script>

<style lang="less" scoped>
.quick-advice {
  .flex-wrap();

  background-color: @color-fill-pale;
  padding: @gutter-lg @gutter @gutter;

  @media @desktop {
    .text-left();
    .flex-no-wrap();

    padding: @gutter-xl @72px;
  }

  .quick-advice__icon {
    .flex-no-grow();
    .flex-no-shrink();

    width: 100%;
    margin: 0 0 @gutter;
    vertical-align: middle;

    @media @desktop {
      width: auto;
      margin: 0 @72px 0 0;
    }
  }

  .h2 {
    margin-bottom: @gutter-sm;

    @media @desktop {
      margin-bottom: @gutter-xs;
    }
  }

  a {
    .font-xl();
    .text-normal();
    .font-headings();

    strong {
      font-weight: 700;
    }

    &.emergency {
      .inline-block();

      color: @color-primary;
      margin-top: @gutter-xs;
    }
  }

  p {
    .font-base();
    .font-body();

    margin: @gutter-lg 0 0;
    padding-top: @gutter-lg;
    border-top: solid 1px @color-fill-muted;

    @media @desktop {
      .font-md();
    }
  }
}

@media print {
  .quick-advice {
    .flex-no-wrap();
    .text-left();

    border: solid @2px @color-border;

    .quick-advice__icon,
    .quick-advice__icon img {
      width: @120px;
    }
  }
}
</style>
